import { createEnum } from "@redotech/zod-util/zod-enum";

export enum FlushReason {
  LIQUIDATE = "liquidate",
  DONATE = "donate",
  DESTROY = "destroy",
}

export const FlushReasonSchema = createEnum(FlushReason, {
  enumName: "FlushReason",
});

export const FLUSH_BIN_NAMES: Record<FlushReason, string> = {
  [FlushReason.LIQUIDATE]: "FLUSH_LIQUIDATE",
  [FlushReason.DONATE]: "FLUSH_DONATE",
  [FlushReason.DESTROY]: "FLUSH_DESTROY",
};

export enum FlushPickStrategy {
  MANUAL = "manual",
  AUTOMATIC = "automatic",
}

export const FlushPickStrategySchema = createEnum(FlushPickStrategy, {
  enumName: "FlushPickStrategy",
});

/**
 * Default age threshold (in days) for the slow-mover branch of the
 * AUTOMATIC pick worklist. A unit's `location_inventory` must have been
 * created MORE than this long ago AND have never had a fulfillment_created
 * or fulfillment_order_created adjustment to be considered a slow mover.
 *
 * Surfaced through `startFlushSession`'s `slowMoverWindowDays` input.
 * Treated as policy, not configuration — bumped here, not per-merchant.
 */
export const DEFAULT_SLOW_MOVER_WINDOW_DAYS = 30;
